import React from 'react';
import Icon from './icon';

export interface IconWithTextProps {
    iconName?: string;
    reverseIconWithText?: boolean;
    text: string;
    className?: string;
}

const IconWithText = ({ iconName, text, reverseIconWithText, className, ...rest }: IconWithTextProps & React.HTMLAttributes<HTMLSpanElement>): React.ReactElement => {

    return (
        <span {...rest}  className={`flex items-center ${reverseIconWithText ? 'flex-row-reverse' : ''}`.concat(className || '')}>
            {
                iconName ? <Icon name={iconName} className={`fill-current ${reverseIconWithText ? 'ml-2' : 'mr-2'}`} style={{ height: '1.5em', width: '1.5em' }} /> : null

            }
            { text }
        </span>
    );
};

export default IconWithText;
